export type EditKeysType = 'SET_SKU' | 'PRODUCTS';

export const EDIT_KEYS = ['SET_SKU', 'PRODUCTS'];

export const STORAGE_KEY = 'productSetEditData';
